//all filters goes here.

import moment from 'moment';


export const selectDateFormat = "DD/MM/YYYY";

export const DateFormat = (date) => {
    return moment(date).format("Do MMMM YYYY");
}
export const wordWrap = (str, maxWidth) => {

    // console.log('IN wordWrap function');

    let newLineStr = "\n";
    let done = false;
    let res = '';
    while (str.length > maxWidth) {
        let found = false;
        // Inserts new line at first whitespace of the line
        for (let i = maxWidth - 1; i >= 0; i--) {
            if (testWhite(str.charAt(i))) {
                res = res + [str.slice(0, i), newLineStr].join('');
                str = str.slice(i + 1);
                found = true;
                break;
            }
        }
        // Inserts new line at maxWidth position, the word is too long to wrap
        if (!found) {
            res += [str.slice(0, maxWidth), newLineStr].join('');
            str = str.slice(maxWidth);
        }

    }
    return res + str;
};

export const testWhite = (x) => {
    let white = new RegExp(/^\s$/);
    return white.test(x.charAt(0));
};

export const excelSerialToDate = (serial) => {
    if (serial && serial!=="01 Jan 1970 05:30 AM") {
        const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        const date = new Date(excelEpoch.getTime() + serial * 86400000);
        return date.toISOString().split('T')[0];
    } else {
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/helper/filters.js